import axios from "axios";
import {getField, updateField} from "vuex-map-fields";
import i18n from '@/i18n';
import Vue from "vue";
import $socket from "@/plugins/socket-instance";

export default {
    namespaced: true,
    state: {
        fetched: false,
        smsGateways:[],
        shopSmsGateways:[],
    },
    getters: {
        getField, //vuex-map-fields
    },
    mutations: {
        updateField, //vuex-map-fields
    },
    actions: {
        async getShopSmsGateways({ commit, state, dispatch }, payload){
            updateField(state, {path:'fetched', value:true});
            await axios.get(this._vm.$apiURL + '/shops/'+payload.shop_id+'/sms-gateways')
                .then((response) => {
                    let data = response.data;
                    updateField(state, {path: 'shopSmsGateways', value: data});
                })
                .catch((error) => {
                    dispatch('common/showError', {'error': error}, {root: true});
                })
        },
        async get({ commit, state, dispatch }){
            updateField(state, {path:'fetched', value:true});
            await axios.get(this._vm.$apiURL + '/sms-gateways')
                .then((response) => {
                    let data = response.data;
                    updateField(state, {path: 'smsGateways', value: data});
                })
                .catch((error) => {
                    dispatch('common/showError', {'error': error}, {root: true});
                })
        },
        async updateShopSmsGateways({ commit, state, dispatch }, payload){
            updateField(state, {path:'fetched', value:false});
            return axios.put(this._vm.$apiURL + '/shops/'+payload.shop_id+'/sms-gateways/'+payload.sms_gateway_id,
                {
                    credentials: payload.credentials,
                    is_default: payload.isDefault
                }
                )
                .then((response) => {
                    this._vm.$inform(this._vm.i18n.t('common.operation_success'));
                })
                .catch((error) => {
                    dispatch('common/showError', {'error': error}, {root:true});
                    return Promise.reject()
                }).finally(()=>{
                    updateField(state, {path:'fetched', value:true});
                })
        },
    }
}
